module.exports = __webpack_public_path__ + "img/secondary_5x4_z18.7e9e14da.svg";